import * as React from "react";
import Modal from "../../../ui/modal/Modal";
import CreateTaskForm from "../form/create/CreateTaskForm";

interface IComponentProps {
	/**
	 * On successful created organisation callback.
	 */
	onSuccess: () => void;
	/**
	 * On cancel button click.
	 */
	onCancel: () => void;
}

export default class CreateTaskModal extends React.Component<IComponentProps, {}> {
	render() {
		return (
			<Modal onCloseClicked={this.props.onCancel} title={"Create Task"} fixedWidth>
				<CreateTaskForm onSuccess={this.props.onSuccess} onCancel={this.props.onCancel}/>
			</Modal>
		);
	}
}
